module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.$route.params.form == undefined) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "competition-item-hatar"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "background-image": "url('assets/img/p01.jpg')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Rendszeres szociális támogatás és költségtérítés mérséklés\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n            Pályázat beadásának kezdete: "), _c('span', [_vm._v(_vm._s(_vm.hataridok.SzocKerelemKitoltesKezdete))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n            Pályázat beadásának kezdete elsősöknek: "), _c('span', [_vm._v(_vm._s(_vm.hataridok.SzocKerelemKitoltesKezdeteElsos))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n            Pályázat beadásának határideje: "), _c('span', [_vm._v(_vm._s(_vm.hataridok.SzocKerelemKitoltesVege))])])]), _vm._v(" "), _c('div', {
    staticClass: "navbar",
    staticStyle: {
      "padding-bottom": "25px"
    }
  }, [(!_vm.RendszeresSzocialisTamogatasGombDisable) ? _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.RendszeresSzocialisTamogatasGombDisable,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.palyazasClick('rendszeres_szocialis_tamogatas')
      }
    }
  }, [_vm._v("Pályázás")]) : _vm._e(), _vm._v(" "), (_vm.urlapKitoltveHatar('RendszeresSzocialisTamogatas')) ? _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.rendszeresSzocialisTamogatasPdf
    }
  }, [_vm._v("Pályázat letöltése")]) : _vm._e(), _vm._v(" "), (_vm.urlapKitoltveHatar('RendszeresSzocialisTamogatas')) ? _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.rendszeresSzocialisTamogatasBiralatPontok
    }
  }, [_vm._v("Pontszámok")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.RendszeresSzocialisTamogatasStatusz)
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n            Reklamációs határidő: "), _c('span', [_vm._v(_vm._s(_vm.hataridok.SzocKerelemReklamacioVege))])])]), _vm._v(" "), _c('div', {
    staticClass: "navbar",
    staticStyle: {
      "padding-bottom": "25px"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.RendszeresSzocialisReklamacioGombDisable,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.palyazasClick('rendszeres_szocialis_reklamacio')
      }
    }
  }, [_vm._v("Reklamáció")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.RendszeresSzocialisReklamacioStatusz)
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n            Korrekciós kérelem beadásának kezdete: "), _c('span', [_vm._v(_vm._s(_vm.hataridok.SzocKerelemKorrekcioKezdete))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n            Korrekciós kérelem beadásának vége: "), _c('span', [_vm._v(_vm._s(_vm.hataridok.SzocKerelemKorrekcioVege))])])]), _vm._v(" "), _c('div', {
    staticClass: "navbar"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.RendszeresSzocialisKorrekciosKerelemGombDisable,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.palyazasClick('korrekcios_kerelem')
      }
    }
  }, [_vm._v("Korrekció")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.RendszeresSzocialisKorrekciosKerelemStatusz)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "competition-item-hatar"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "background-image": "url('assets/img/p02.jpg')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Kiemelkedő sport tevékenység támogatása\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n            Pályázat beadásának határideje: "), _c('span', [_vm._v(_vm._s(_vm.hataridok.KiemelkedoKitoltesVege))])])]), _vm._v(" "), _c('div', {
    staticClass: "navbar"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.KiemelkedoSportTamogatasGombDisable,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.palyazasClick('kiemelkedo_sport_tamogatas')
      }
    }
  }, [_vm._v("Pályázás")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.KiemelkedoSportTamogatasStatusz)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "competition-item-hatar"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "background-image": "url('assets/img/p04.jpg')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Kiemelkedő tudományos, kulturális pályázat\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n            Pályázat beadásának határideje: "), _c('span', [_vm._v(_vm._s(_vm.hataridok.KiemelkedoKitoltesVege))])])]), _vm._v(" "), _c('div', {
    staticClass: "navbar"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.KiemelkedoTudomanyosKulturalisTamogatasGombDisable,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.palyazasClick('kiemelkedo_tudomanyos_kulturalis_tamogatas')
      }
    }
  }, [_vm._v("Pályázás")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.KiemelkedoTudomanyosKulturalisTamogatasStatusz)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "competition-item-hatar"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "background-image": "url('assets/img/p03.jpg')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Rendkívüli szociális ösztöndíj\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n            Pályázat beadásának kezdete: "), _c('span', [_vm._v(_vm._s(_vm.hataridok.SzocKerelemKitoltesKezdete))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n            Pályázat beadásának vége: "), _c('span', [_vm._v(_vm._s(_vm.hataridok.RendkivuliKitoltesVege))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "navbar"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.RendkivuliSzocialisTamogatasGombDisable,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.palyazasClick('rendkivuli_szocialis_tamogatas')
      }
    }
  }, [_vm._v("Pályázás")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.RendkivuliSzocialisTamogatasStatusz)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "competition-item-hatar"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "background-image": "url('assets/img/p07.jpg')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Külföldre ösztöndíjat nyert hallgatók útiköltségének támogatása\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n            Pályázat beadásának kezdete: "), _c('span', [_vm._v(_vm._s(_vm.hataridok.KulfoldiUtikoltsegPalyazatKezdete))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n            Pályázat beadásának határideje: "), _c('span', [_vm._v(_vm._s(_vm.hataridok.KulfoldiUtikoltsegPalyazatVege))])])]), _vm._v(" "), _c('div', {
    staticClass: "navbar"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.KulfoldiUtikoltsegPalyazatGombDisable,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.palyazasClick('kulfoldi_utikoltseg_palyazat')
      }
    }
  }, [_vm._v("Pályázás")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.KulfoldiUtikoltsegPalyazatStatusz)
    }
  })])])])]), _vm._v(" "), (_vm.hokTag) ? _c('div', {
    staticClass: "competition-item-hatar"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "background-image": "url('assets/img/p05.jpg')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        HÖK és Hallgatói Szervezetek kulturális rendezvényeinek támogatása\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n            Pályázat beadásának kezdete: "), _c('span', [_vm._v(_vm._s(_vm.ktr_hataridok.HokKultKitoltesKezdete))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n            Pályázat beadásának határideje: "), _c('span', [_vm._v(_vm._s(_vm.ktr_hataridok.HokKultKitoltesVege))])])]), _vm._v(" "), _c('div', {
    staticClass: "navbar"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.RendezvenySzervezesTamogatasiPalyazatGombDisable,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.palyazasClick('rendezveny_szervezes_tamogatasi_palyazat')
      }
    }
  }, [_vm._v("Pályázás")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.RendezvenySzervezesTamogatasiPalyazatStatusz)
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.hokTag) ? _c('div', {
    staticClass: "competition-item-hatar"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "background-image": "url('assets/img/p06.jpg')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Tanulmányi kirándulás támogatása\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n            Pályázat beadásának kezdete: "), _c('span', [_vm._v(_vm._s(_vm.ktr_hataridok.TankirKitoltesKezdete))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-info-cirScle"
  }), _vm._v("\n            Pályázat beadásának határideje: "), _c('span', [_vm._v(_vm._s(_vm.ktr_hataridok.TankirKitoltesVege))])])]), _vm._v(" "), _c('div', {
    staticClass: "navbar"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.TanulmanyiKirandulasPalyazatGombDisable,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.palyazasClick('tanulmanyi_kirandulas_palyazat')
      }
    }
  }, [_vm._v("Pályázás")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.TanulmanyiKirandulasPalyazatStatusz)
    }
  })])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$route.params.form != undefined && _vm.$route.params.form == 'rendkivuli_szocialis_tamogatas') ? _c('RendkivuliSzocialisTamogatas') : _vm._e(), _vm._v(" "), (_vm.$route.params.form != undefined && _vm.$route.params.form == 'rendszeres_szocialis_tamogatas') ? _c('RendszeresSzocialisTamogatas') : _vm._e(), _vm._v(" "), (_vm.$route.params.form != undefined && _vm.$route.params.form == 'kiemelkedo_sport_tamogatas') ? _c('KiemelkedoSportTamogatas') : _vm._e(), _vm._v(" "), (_vm.$route.params.form != undefined && _vm.$route.params.form == 'kiemelkedo_tudomanyos_kulturalis_tamogatas') ? _c('KiemelkedoTudomanyosKulturalisTamogatas') : _vm._e(), _vm._v(" "), (_vm.$route.params.form != undefined && _vm.$route.params.form == 'kulfoldi_utikoltseg_palyazat') ? _c('KulfoldiUtikoltsegPalyazat') : _vm._e(), _vm._v(" "), (_vm.$route.params.form != undefined && _vm.$route.params.form == 'rendezveny_szervezes_tamogatasi_palyazat' && _vm.hokTag) ? _c('RendezvenySzervezesTamogatasiPalyazat') : _vm._e(), _vm._v(" "), (_vm.$route.params.form != undefined && _vm.$route.params.form == 'tanulmanyi_kirandulas_palyazat' && _vm.hokTag) ? _c('TanulmanyiKirandulasPalyazat') : _vm._e(), _vm._v(" "), (_vm.$route.params.form != undefined && _vm.$route.params.form == 'korrekcios_kerelem') ? _c('KorrekciosKerelem') : _vm._e(), _vm._v(" "), (_vm.$route.params.form != undefined && _vm.$route.params.form == 'rendszeres_szocialis_reklamacio') ? _c('RendszeresSzocialisReklamacio') : _vm._e(), _vm._v(" "), (_vm.szocialisPontokPopup) ? _c('RendszeresSzocialisPontok', {
    on: {
      "onClose": function($event) {
        _vm.szocialisPontokPopup = false;
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" "), _c('span', [_vm._v("Minden hónap 20-ig")]), _vm._v(" beérkezett pályázatok kerülnek elbírálásra a következő hónapra\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n            Januárban és júniusban nem lehet beadni\n          ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-342d4d52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/hatar.vue
// module id = 352
// module chunks = 0